@if (
  showReservationCountdown() &&
  partner()?.is_appointment_reservation_enabled &&
  partner()?.x_minutes_appointment_reservation
) {
  <div>
    @if (!isReservationExpired()) {
      @if (remainingTimeText()) {
        <span
          class="cbw-reservation-timer success"
          ngbTooltip="{{ 'reservation_timer.reservation_time_remaining_tooltip' | translate }}"
        >
          {{ 'reservation_timer.reservation_time_remaining' | translate: { time: remainingTimeText() } }}
        </span>
      }
    }
    <span role="status" aria-live="polite">
      @if (isReservationExpired()) {
        <span
          class="cbw-reservation-timer danger"
          ngbTooltip="{{ 'reservation_timer.reservation_expired_tooltip' | translate }}"
        >
          {{ 'reservation_timer.reservation_expired' | translate }}
        </span>
      }
    </span>
    <br>
  </div>
}
